// retouch.js (förändringar markerade i createTable/addListeners/update)
import Table from './table.js';
import events from './event.js';
import products from './products.js';
import Storage from './storage.js';
import { textString } from './texts.js';
import Logger from './logger.js';

import { ensureMsap, isMsapAvailable } from './msapBridge-loader.js';
import { getVisibleRetouchValues } from './msapBridge-retouch.js';

class Retouch {
    customizerContentDiv = null;
    attr = null;
    wrapperDiv = null;
    retouchDiv = null;
    table = null;

    constructor(customizerContentDiv) {
        this.customizerContentDiv = customizerContentDiv;
        if (!customizerContentDiv) {
            Logger.error('Retouch step failed to load.');
            return;
        }
        this.init();
    }

    async init() {
        await this.createWrapper();
        await this.addCommentSection();
        await this.createTable();
        this.addListeners();
    }

    async createWrapper() {
        if (this.wrapperDiv) {
            this.wrapperDiv.style.display = 'flex';
            return;
        }
        this.wrapperDiv = document.createElement('div');
        this.wrapperDiv.classList.add('mscp-retouch-wrapper');
        this.customizerContentDiv.appendChild(this.wrapperDiv);

        this.retouchDiv = document.createElement('div');
        this.retouchDiv.classList.add('mscp-retouch-list', 'mscp-table');
        this.wrapperDiv.appendChild(this.retouchDiv);
    }

    async createTable() {
        // Add all retouch terms
        const retouchs = await products.getRetouchs();
        const retouchProducts = await products.getRetouchProducts();

        this.table = new Table({
            'wrapperDiv': this.retouchDiv,
            'terms': retouchs, // ← alla
            'type': 'retouch',
            'selectCallback': async (el, value) => {
                this.showCommentSection(el.dataset.leave_a_comment);
                events.trigger('setStackDataset', 'retouch', value);
            },
            'extraDataAttributes': ['leave_a_comment'],
            'postCreateTitleCallback': (term) => {
                const price = document.createElement('span');
                price.classList.add('mscp-retouch-price', 'mscp-column', 'mscp-post-create');
                const variation = retouchProducts[term.value];
                price.innerHTML = `+ ${variation?.wc_price || term?.wc_price || '0'}`;
                return price;
            },
            'postInitSelectedItemsCallback': (selectedItem) => {
                selectedItem && this.showCommentSection(selectedItem.dataset.leave_a_comment);
            }
        });
    }

    addListeners() {
        // update when step changes to retouch
        events.add('stepChanged', (step) => {
            if (step === 'retouch') {
                this.update();
            }
        });

        // events.add('updateNavigation', () => {
        //     // call gently, possibly throttle if needed
        //     this.update();
        // }, { throttle: 200 });

        events.add('reInitUpload', () => {
            this.table.deselectAll();
            events.trigger('setStackDataset', 'retouch', '');
        });

    }

    async update() {

        if (!this.table) return;

        // Try to fetch data from MSAP
        await ensureMsap();
        if (!isMsapAvailable()) {
            // Show all
            return;
        }

        // If MSAP is available

        // Context for include/exclude:
        const productIds = await products.getAttributeHierarchyProductIDs();
        const productId = productIds.length >= 1 ? productIds[0] : null;

        const product = await products.getProduct(productId);
        const categoryIds = product?.product_cat || [];

        // Ask the bridge for visible retouch values:
        const visibleValues = await getVisibleRetouchValues({
            productId,
            categoryIds
        });

        // Show/hide rows
        this.table.updateVisibleItems(visibleValues);
    }

    async addCommentSection() {
        const commentLabelText = textString('retouch_comment_label');
        this.commentRow = document.createElement('div');
        this.commentRow.classList.add('mscp-item', 'comment', 'hidden');

        if (commentLabelText) {
            const commentLabel = document.createElement('label');
            commentLabel.setAttribute('for', 'comment');
            commentLabel.innerHTML = commentLabelText;
            this.commentRow.appendChild(commentLabel);
        }

        const commentPlaceholder = textString('retouch_comment_placeholder', _("Enter your comment here..."));
        const commentTextarea = document.createElement('textarea');
        commentTextarea.setAttribute('id', 'comment');
        commentTextarea.setAttribute('name', 'comment');
        commentTextarea.setAttribute('rows', '4');
        commentTextarea.setAttribute('cols', '50');
        commentTextarea.setAttribute('placeholder', commentPlaceholder);

        this.commentRow.appendChild(commentTextarea);
        this.wrapperDiv.appendChild(this.commentRow);

        commentTextarea.addEventListener('change', (e) => {
            const comment = e.target.value;
            Storage.save('retouch_comment', comment);
        });
    }

    showCommentSection(leave_a_comment) {
        leave_a_comment = leave_a_comment === 'true' || leave_a_comment === true;
        if (leave_a_comment) {
            this.commentRow.classList.remove('hidden');
            this.commentRow.querySelector('textarea').focus();
        } else {
            this.commentRow.classList.add('hidden');
        }
    }
}

export default Retouch;